import { Box } from "@mui/material";

import type { FC } from "react";

const logo =
  "https://images.changeengine.com/b89bd028-0199-47a5-8276-eb4b17cd4d73/9a930869-5be6-4651-8f66-0075107af193";

export const DashboardBackground: FC = () => (
  <Box
    component="img"
    src={logo}
    alt=""
    aria-hidden
    sx={{
      // Fixed to the viewport, so it stays in view as the page scrolls. Fixed elements are never
      // scroll anchors, so it doesn't make the page jump as Load more adds to Recently edited.
      position: "fixed",
      right: "-566px",
      bottom: "-1022px",
      width: 2344,
      maxWidth: "none",
      opacity: 0.15,
      zIndex: -1,
      pointerEvents: "none",
      userSelect: "none",
    }}
  />
);
